import { BrowserRouter as Router, Routes, Route, useNavigate, useParams, Link, Outlet } from 'react-router-dom'
import { Canvas } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import { useGLTF } from '@react-three/drei'
import { useEffect, useRef, useState } from 'react'
// import imageMapResize from 'image-map-resizer'
import imageMapResize from 'image-map-resizer'

function useDeviceType() {
  const [deviceType, setDeviceType] = useState('desktop');

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width < 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    updateDeviceType();
    window.addEventListener('resize', updateDeviceType);
    return () => window.removeEventListener('resize', updateDeviceType);
  }, []);

  return deviceType;
}

// 
function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => setMenuOpen(!menuOpen)
  return (
    <header 
      style={{
        backgroundColor:'#eee',
        padding:'1rem',
        textAlign:'center',
        display:'flex',
        // flexDirection:'column',
        alignItems:'center',
        gap:'1rem',
        flexWrap:'wrap',
        justifyContent:'space-between'
      }}
    >
      <div
        style={{
          display:'flex',
          alignItems:'center',
          gap:'0.5rem'
        }}
      >
        <img
          src='/logo.jpg'
          alt='logo'
          style={{
            width:'40px',
            height:'40px'
          }}
        />
        <h2
          style={{
            margin:0,
          }}
        >
          <Link 
            to={'/'} 
            style={{
              textDecoration:'none', 
              color:'black'
            }}
          >
            Application Sport
          </Link>
        </h2>
      </div>
      <button
        onClick={toggleMenu}
        style={{
          background: 'none',
          border: 'none',
          fontSize: '1.5rem',
          display: 'block', // visible par défaut
          cursor: 'pointer'
        }}
        className="hamburger"
      >
        ☰
      </button>
      <nav 
        style={{
          display:menuOpen?'flex':'none',
          flexDirection:'column',
          marginTop:'1rem',
          gap:'1rem',
          flexWrap:'wrap',
          justifyContent:'center',
          width:'100%'
        }}
        className='nav-links'
      >
        <Link 
          to={'/'} 
          style={{
            color:'black', 
            textDecoration:'none'
          }}
        >
          Notre histoire
        </Link>
        <Link 
          to={'/'} 
          style={{
            color:'black', 
            textDecoration:'none'
          }}
        >
          Nos produits
        </Link>
        <Link 
          to={'/'} 
          style={{
            color:'black', 
            textDecoration:'none'
          }}
        >
          Nos services
        </Link>
        <Link 
          to={'/'} 
          style={{
            color:'black', 
            textDecoration:'none'
          }}
        >
          S'inscrire
        </Link>
        <Link 
          to={'/'} 
          style={{
            color:'black', 
            textDecoration:'none'
          }}
        >
          Se connecter
        </Link>
      </nav>
    </header>
  )
}

// 
function Footer() {
    return (
        <footer 
          style={{
            backgroundColor:'#eee',
            padding:'1rem',
            textAlign:'center'
          }}
        >
          <p>© 2025 - Application Sport</p>
        </footer>
    )
}

// 
function Layout() {
    return (
        <div 
          style={{
            display:'flex',
            flexDirection:'column',
            minHeight:'100vh'
          }}
        >
          <Header />
          <main 
            style={{
              flex:1, 
              maxWidth:'100vw', 
              overflowX:'hidden'
            }}
          >
            <Outlet />
          </main>
          <Footer />
        </div>
    )
}

// 
function PagePartie() {
  const { nom } = useParams();

  return (
    <div 
      style={{ 
        padding: '2rem', 
        textAlign: 'center' 
      }}
    >
      <h1>Partie sélectionnée : {nom}</h1>
      <p>Instructions pour la partie du corps : {nom}</p>
      {/* <video width="400" controls>
        <source src={`/videos/${nom}.mp4`} type="video/mp4" />
        Votre navigateur ne supporte pas la lecture de cette vidéo.
      </video> */}
      <img 
        src={`/${nom}.jpg`} 
        style={{
          maxWidth:'100%',
          height:'auto'
        }}
        alt={`Partie du corps : ${nom}`}
      />
      <div>
        <Link 
          to={'/'} 
        >
          retour
        </Link>
      </div>
    </div>
  );
}

// 
function Personnage(props) {
  const { scene } = useGLTF('/characterComplet2.glb');
  // const { scene } = useGLTF('/testCharacter3.glb');
  // const { scene } = useGLTF('/male_body.glb');
  const [hoveredName, setHoveredName] = useState(null);
  const navigate = useNavigate();
  console.log(scene)
  return (
    <group {...props}>
      {scene.children.map((child, index) => {
        const isCube = child.name === 'Cube';
        scene.children.sort((a, b) => b.position.z - a.position.z);
        // Clone le matériau pour éviter les conflits entre parties
        const material = child.material.clone();
        if (!isCube && child.name === hoveredName) {
          material.color.set('grey'); // ou la couleur que tu veux
        }
        if (isCube) {
          material.color.set('white')
        }

        return (
          <mesh
            key={index}
            geometry={child.geometry}
            material={material}
            onPointerOver={(e) => {
              if (isCube) return;
              e.stopPropagation();
              document.body.style.cursor = 'pointer';
              setHoveredName(child.name);
            }}
            onPointerOut={(e) => {
              if (isCube) return;
              e.stopPropagation();
              document.body.style.cursor = 'default';
              setHoveredName(null);
            }}
            onClick={() => {
              if (isCube) return;
              // alert('Partie cliquée : ' + child.name);
              navigate(`/partie/${child.name.toLowerCase()}`);
            }}
          />
        );
      })}
    </group>
  );
}

// 
function Scene3D() {
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();
  const zones = [
    { name: 'pectoraux', points: '284,231 224,225 197,286 208,313 235,321 269,314 285,292' },
    { name: 'pectoraux', points: '296,231 296,292 310,311 333,318 352,318 371,307 379,292 372,259 361,237 338,221' },
    { name: 'pectoraux', points: '722,235 685,288 681,309 688,319 715,313 735,300 731,262' },
    { name: 'epaules', points: '205,222 177,221 154,238 148,263 148,286 154,306 185,286' },
    { name: 'epaules', points: '380,213 413,227 428,257 430,285 426,303 396,284 365,223' },
    { name: 'epaules_side', points: '783,208 754,222 738,245 739,269 749,289 764,302 788,302 813,285 818,254 810,220' },
    { name: 'epaules_back', points: '1146,219 1115,214 1092,233 1084,259 1084,290 1120,275 1145,242 1157,227' },
    { name: 'abdominaux', points: '288,318 243,328 239,359 243,397 253,454 288,459 327,454 335,405 339,366 338,328' },
    { name: 'abdominaux', points: '688,320 715,313 712,363 712,403 710,461 692,462 689,406 685,363' },
    { name: 'cuisses', points: '200,547 254,555 276,635 269,678 255,688 238,674 232,639 215,676 198,640 194,605' },
    { name: 'cuisses', points: '323,556 372,546 377,621 367,668 354,661 344,638 341,675 320,687 304,664 303,629' },
    { name: 'cuisses', points: '741,553 727,590 714,592 701,605 718,645 729,677 760,691 779,672 783,617 783,576 773,553' },
    { name: 'arriereCuisses', points: '1146,553 1195,562 1204,607 1200,650 1192,691 1184,710 1145,700 1138,650 1135,595' },
    { name: 'arriereCuisses', points: '1252,562 1298,555 1309,585 1311,620 1309,650 1307,676 1309,711 1259,711 1245,665 1238,601' },
    { name: 'dorsaux', points: '1157,222 1184,212 1211,222 1217,321 1198,319 1173,281 1157,250' },
    { name: 'dorsaux', points: '1236,223 1257,212 1284,213 1293,223 1287,249 1276,280 1248,318 1233,315' },
    { name: 'triceps', points: '750,298 741,340 748,379 777,390 810,379 821,280 785,306' },
    { name: 'bispes', points: '392,285 377,301 381,332 392,376 414,385 438,365 441,324 430,300' },
    { name: 'bispes', points: '188,286 198,304 196,332 186,365 179,377 154,388 137,371 139,339 146,298' },
  ];
  const deviceType = useDeviceType();

  useEffect(() => {
    imageMapResize(); // ajuste automatiquement les coords à la taille de l'image
  }, []);

  return (
    <>
      <div
        style={{
          width:'100%',
          height:'100%',
          textAlign:'center'
        }}
      >
        {deviceType === 'desktop' && (
          <>
            <img 
              src='/img_face_side_back_sansbg2.png' 
              useMap='#facesideback'
              style={{
                width:'100%',
                height:'100%',
              }}  
            />
            <map name='facesideback'>
              <area 
                // onMouseOver="document.body.style.cursor='pointer'" 
                // onMouseOut="document.body.style.cursor='default'"
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='284,231,224,225,197,286,208,313,235,321,269,314,285,292'
                // href='/partie/pectoraux'
                onClick={() => navigate('/partie/pectoraux')}
                rel='nofollow noreferrer noopener'
                alt='pectoraux'
                title='Ouvrir les pectoraux'
                className='pectoraux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='296,231,296,292,310,311,333,318,352,318,371,307,379,292,372,259,361,237,338,221'
                // href='/partie/pectoraux'
                onClick={() => navigate('/partie/pectoraux')}
                rel='nofollow noreferrer noopener'
                alt='pectoraux'
                title='Ouvrir les pectoraux'
                className='pectoraux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='722,235,685,288,681,309,688,319,715,313,735,300,731,262'
                // href='/partie/pectoraux'
                onClick={() => navigate('/partie/pectoraux')}
                rel='nofollow noreferrer noopener'
                alt='pectoraux'
                title='Ouvrir les pectoraux'
                className='pectoraux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='205,222,177,221,154,238,148,263,148,286,154,306,185,286'
                // href='/partie/epaule'
                onClick={() => navigate('/partie/epaule')}
                rel='nofollow noreferrer noopener'
                alt='epaules'
                title='Ouvrir les épaules'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='380,213,413,227,428,257,430,285,426,303,396,284,365,223'
                // href='/partie/epaule'
                onClick={() => navigate('/partie/epaule')}
                rel='nofollow noreferrer noopener'
                alt='epaules'
                title='Ouvrir les épaules'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='783,208,754,222,738,245,739,269,749,289,764,302,788,302,813,285,818,254,810,220'
                // href='/partie/epaules_side'
                onClick={() => navigate('/partie/epaule')}
                rel='nofollow noreferrer noopener'
                alt='epaules_side'
                title='Ouvrir les épaules de côté'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='1146,219,1115,214,1092,233,1084,259,1084,290,1120,275,1145,242,1157,227'
                // href='/partie/epaules_back'
                onClick={() => navigate('/partie/epaule')}
                rel='nofollow noreferrer noopener'
                alt='epaules_back'
                title='Ouvrir les épaules arrières'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='288,318,243,328,239,359,243,397,253,454,288,459,327,454,335,405,339,366,338,328'
                // href='/partie/abdominaux'
                onClick={() => navigate('/partie/abdominaux')}
                rel='nofollow noreferrer noopener'
                alt='abdominaux'
                title='Ouvrir les abdominaux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='688,320,715,313,712,363,712,403,710,461,692,462,689,406,685,363'
                // href='/partie/abdominaux'
                onClick={() => navigate('/partie/abdominaux')}
                rel='nofollow noreferrer noopener'
                alt='abdominaux'
                title='Ouvrir les abdominaux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='200,547,254,555,276,635,269,678,255,688,238,674,232,639,215,676,198,640,194,605'
                // href='/partie/cuisses'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='cuisses'
                title='Ouvrir les cuisses'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='323,556,372,546,377,621,367,668,354,661,344,638,341,675,320,687,304,664,303,629'
                // href='/partie/cuisses'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='cuisses'
                title='Ouvrir les cuisses'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='741,553,727,590,714,592,701,605,718,645,729,677,760,691,779,672,783,617,783,576,773,553'
                // href='/partie/cuisses'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='cuisses'
                title='Ouvrir les cuisses'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='1146,553,1195,562,1204,607,1200,650,1192,691,1184,710,1145,700,1138,650,1135,595'
                // href='/partie/arriereCuisses'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='arrirere_cuisses'
                title='Ouvrir les arrièrees cuisses'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='1252,562,1298,555,1309,585,1311,620,1309,650,1307,676,1309,711,1259,711,1245,665,1238,601'
                // href='/partie/arriereCuisses'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='arrirere_cuisses'
                title='Ouvrir les arrièrees cuisses'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='1157,222,1184,212,1211,222,1217,321,1198,319,1173,281,1157,250'
                // href='/partie/dorsaux'
                onClick={() => navigate('/partie/dorsaux')}
                rel='nofollow noreferrer noopener'
                alt='dorsaux'
                title='Ouvrir les dorsaux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='1236,223,1257,212,1284,213,1293,223,1287,249,1276,280,1248,318,1233,315'
                // href='/partie/dorsaux'
                onClick={() => navigate('/partie/dorsaux')}
                rel='nofollow noreferrer noopener'
                alt='dorsaux'
                title='Ouvrir les dorsaux'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='750,298,741,340,748,379,777,390,810,379,821,280,785,306'
                // href='/partie/triceps'
                onClick={() => navigate('/partie/triceps')}
                rel='nofollow noreferrer noopener'
                alt='triceps'
                title='Ouvrir les triceps'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='392,285,377,301,381,332,392,376,414,385,438,365,441,324,430,300'
                // href='/partie/bispes'
                onClick={() => navigate('/partie/bispes')}
                rel='nofollow noreferrer noopener'
                alt='biseps'
                title='Ouvrir les biseps'
              />
              <area 
                onMouseOver={() => document.body.style.cursor = 'pointer'} 
                onMouseOut={() => document.body.style.cursor = 'default'}
                shape='poly'
                coords='188,286,198,304,196,332,186,365,179,377,154,388,137,371,139,339,146,298'
                // href='/partie/bispes'
                onClick={() => navigate('/partie/bispes')}
                rel='nofollow noreferrer noopener'
                alt='biseps'
                title='Ouvrir les biseps'
              />
            </map>
          </>
        )}
        {deviceType !== 'desktop' && (
          <>
            <img
              src='/img_mobile_tablette.png'
              useMap='#mobiletablettemap'
              style={{width:'318px',height:'100%', margin:'auto'}}
            />
            <map name='mobiletablettemap'>
              <area
                shape='poly'
                coords='108,155,92,178,79,212,98,229,121,235,148,232,158,213,158,161'
                onClick={() => navigate('/partie/pectoraux')}
                rel='nofollow noreferrer noopener'
                alt='pectoraux'
                title='Ouvrir les pectoraux'
              />
              <area
                shape='poly'
                coords='166,162,166,217,180,232,199,237,222,231,234,221,232,189,219,163,200,155'
                onClick={() => navigate('/partie/pectoraux')}
                rel='nofollow noreferrer noopener'
                alt='pectoraux'
                title='Ouvrir les pectoraux'
              />
              <area
                shape='poly'
                coords='94,157,78,152,60,161,50,180,46,200,47,217,49,224,75,205'
                onClick={() => navigate('/partie/epaule')}
                rel='nofollow noreferrer noopener'
                alt='epaule'
                title='Ouvrir les épaules'
              />
              <area
                shape='poly'
                coords='226,157,243,150,262,163,276,187,277,210,277,224,248,209'
                onClick={() => navigate('/partie/epaule')}
                rel='nofollow noreferrer noopener'
                alt='epaule'
                title='Ouvrir les épaules'
              />
              <area
                shape='poly'
                coords='162,232,122,242,122,270,126,301,132,352,162,353,193,352,198,304,203,273,202,242'
                onClick={() => navigate('/partie/abdominaux')}
                rel='nofollow noreferrer noopener'
                alt='abdominaux'
                title='Ouvrir les abdominaux'
              />
              <area
                shape='poly'
                coords='74,207,45,223,39,251,40,275,57,294,75,283,85,243,85,219'
                onClick={() => navigate('/partie/bispes')}
                rel='nofollow noreferrer noopener'
                alt='biceps'
                title='Ouvrir les biceps'
              />
              <area
                shape='poly'
                coords='245,207,281,224,284,253,283,274,267,291,248,285,237,250,234,223'
                onClick={() => navigate('/partie/bispes')}
                rel='nofollow noreferrer noopener'
                alt='biceps'
                title='Ouvrir les biceps'
              />
              <area
                shape='poly'
                coords='94,423,88,473,98,519,110,515,116,490,122,532,136,539,147,520,150,493,142,455,131,424'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='cuisses'
                title='Ouvrir les cuisses'
              />
              <area
                shape='poly'
                coords='192,431,174,493,181,535,193,536,202,530,208,488,219,518,229,509,235,468,231,423'
                onClick={() => navigate('/partie/cuisses')}
                rel='nofollow noreferrer noopener'
                alt='cuisses'
                title='Ouvrir les cuisses'
              />
            </map>
          </>
        )}
      </div>
    
      {/* <div 
        style={{ 
          width: '100%', 
          height: '60vh',
          maxWidth: '100vw',
          overflowX: 'hidden' 
        }}
      >
        <Canvas 
          camera={{ 
            position: [0, 2, 5], 
            fov: 50 
          }}
        >
          <ambientLight />
          <directionalLight 
            position={[5, 5, 5]} 
          />
          <Personnage 
            scale={0.5} 
            position={[0, 0.5, 0]} 
          />
          <OrbitControls />
        </Canvas>
      </div> */}
    </>
  );
}

// FONCTION PRINCIPALE DU PROJET
// POUR L'INSTANT IL Y A 2 ROUTES :
// 1) PATH='/' => SCENE3D
// 2) PATH='/PARTIE/:NOM' => PAGEPARTIE | NOM = NOM DE LA PARTIE DU CORPS SELECTIONNE
function App() {
  return (
    <Router>
      <Routes>
        <Route 
          path='/' 
          element={<Layout />}
        >
          <Route 
            index 
            element={<Scene3D />} 
          />
          <Route 
            path='partie/:nom' 
            element={<PagePartie />} 
          />
        </Route>
        {/* <Route path="/" element={<Scene3D />} />
        <Route path="/partie/:nom" element={<PagePartie />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
